const Q = ["gold", "purple", "blue"];

export const PieceEditor = ({ p, catalog, onChange }) => {
  const kind = ["weapon", "armor"].includes(p.slot) ? "armament" : "adornment";
  const sets = Object.values(catalog.sets).filter((s) => s.kind === kind).map((s) => s.name).sort();
  const set = (k, v) => onChange({ ...p, [k]: v });
  const setMain = (m) => onChange({ ...p, main: m, mainVal: catalog.mainValue[m] || p.mainVal });
  const setSub = (i, k, v) => {
    const subs = [...(p.subs || [])];
    subs[i] = { ...(subs[i] || { stat: "", val: "", q: "purple" }), [k]: v };
    if (k === "stat" || k === "q") {
      const r = catalog.roll[subs[i].stat];
      if (r) subs[i].val = r[Q.indexOf(subs[i].q || "purple")];
    }
    onChange({ ...p, subs: subs.filter((s) => s.stat) });
  };
  const id = `pe-${p.slot}`;
  return (
    <div className="lg-pe" data-testid={`piece-editor-${p.slot}`}>
      <div className="lg-pe-row">
        <select className="lg-input" value={p.set} onChange={(e) => set("set", e.target.value)} data-testid={`${id}-set`}>
          {sets.map((s) => <option key={s}>{s}</option>)}
        </select>
        <input className="lg-input" style={{ width: 56 }} value={p.level ?? 16} onChange={(e) => set("level", e.target.value)} title="Level" data-testid={`${id}-level`} />
      </div>
      <div className="lg-pe-row">
        <select className="lg-input" value={p.main} onChange={(e) => setMain(e.target.value)} disabled={kind === "armament"} data-testid={`${id}-main`}>
          {catalog.mainOptions[p.slot].map((m) => <option key={m}>{m}</option>)}
        </select>
        <input className="lg-input" style={{ width: 90 }} value={p.mainVal || ""} onChange={(e) => set("mainVal", e.target.value)} data-testid={`${id}-mainval`} />
      </div>
      {[0, 1, 2, 3].map((i) => {
        const s = (p.subs || [])[i] || { stat: "", val: "", q: "purple" };
        return (
          <div className="lg-pe-row" key={i}>
            <select className="lg-input" style={{ flex: "2 1 auto" }} value={s.stat} onChange={(e) => setSub(i, "stat", e.target.value)} data-testid={`${id}-sub${i}`}>
              <option value="">—</option>
              {catalog.subOptions.filter((o) => o !== p.main || o === s.stat).map((o) => <option key={o}>{o}</option>)}
            </select>
            <input className="lg-input" style={{ flex: "0 0 76px" }} value={s.val} onChange={(e) => setSub(i, "val", e.target.value)} disabled={!s.stat} data-testid={`${id}-sub${i}-val`} />
            <select className="lg-input" style={{ flex: "0 0 84px" }} value={s.q || "purple"} onChange={(e) => setSub(i, "q", e.target.value)} disabled={!s.stat} data-testid={`${id}-sub${i}-q`}>
              {Q.map((q) => <option key={q}>{q}</option>)}
            </select>
          </div>
        );
      })}
    </div>
  );
};
